// Vanilla CSS for BaseModal ("Playful Frost" glass shell). Prefix: bm-.
// Aggregated into libraryStyles (injected once). react-modal's backdrop/centering
// stay on the inline `style` prop; everything visible is the .bm-card below.
export const modalStyles = `
  .bm-overlay { animation: bm-fade var(--duration-base) var(--ease-standard); }

  .bm-card {
    font-family: var(--font-sans);
    display: flex;
    flex-direction: column;
    max-height: calc(100vh - 2rem);
    background: var(--glass-popover-bg-strong);
    -webkit-backdrop-filter: var(--glass-popover-filter);
    backdrop-filter: var(--glass-popover-filter);
    border: 1.5px solid var(--glass-border);
    border-radius: var(--rad-catchup-xlarge);
    box-shadow: var(--glass-flat-edge), 0 30px 70px -24px rgba(15, 72, 89, 0.5);
    overflow: hidden;
    animation: bm-pop var(--duration-slow) var(--ease-glass);
  }

  .bm-w-sm { width: min(600px, calc(100vw - 2rem)); }
  .bm-w-md { width: min(900px, calc(100vw - 2rem)); }
  .bm-w-lg { width: min(600px, calc(100vw - 2rem)); }
  @media (min-width: 1024px) { .bm-w-lg { width: min(900px, calc(100vw - 2rem)); } }
  @media (min-width: 1280px) { .bm-w-lg { width: min(1200px, calc(100vw - 2rem)); } }
  @media (min-width: 1536px) { .bm-w-lg { width: min(1500px, calc(100vw - 2rem)); } }

  .bm-header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-4);
    padding: var(--space-4) var(--space-6);
    flex-shrink: 0;
    border-bottom: 1px solid var(--glass-border);
    background: var(--sheen-soft);
  }
  .bm-head-left {
    display: flex;
    align-items: center;
    gap: var(--space-3);
    min-width: 0;
  }
  .bm-icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: var(--rad-catchup-full);
    font-size: var(--fs-xl);
    line-height: 1;
    background: radial-gradient(
      circle at 32% 26%,
      rgba(255, 255, 255, 0.95),
      rgba(115, 215, 230, 0.22)
    );
    border: 1px solid rgba(255, 255, 255, 0.7);
    box-shadow:
      inset 1.5px 2.5px 0 -1px rgba(255, 255, 255, 0.9),
      inset -2px -2px 0 -2px rgba(255, 255, 255, 0.5),
      0 8px 18px -10px rgba(15, 72, 89, 0.45),
      0 0 0 5px rgba(87, 194, 211, 0.10);
  }
  .bm-title {
    font-size: var(--fs-2xl);
    font-weight: 700;
    color: var(--text-primary);
    line-height: 1.2;
    min-width: 0;
  }
  /* truncateTitle (opt-in): one line, cut with "…"; the full title is in the tooltip. */
  .bm-title--truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .bm-head-left:has(.bm-title--truncate) { flex: 1; }
  .bm-title-tip { max-width: 480px; overflow-wrap: anywhere; z-index: 10001; }
  .bm-close {
    width: 36px;
    height: 36px;
    flex-shrink: 0;
    border-radius: 50%;
    border: none;
    cursor: pointer;
    font-size: 15px;
    font-weight: 700;
    color: var(--accent-coral-text);
    background: var(--accent-coral-bg);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background var(--duration-base) var(--ease-standard),
      transform var(--duration-base) var(--ease-standard);
  }
  .bm-close:hover { background: var(--accent-coral-border); transform: rotate(90deg); }

  .bm-body {
    padding: var(--space-4) var(--space-6) var(--space-6);
    overflow-y: auto;
    flex: 1 1 auto;
  }

  @keyframes bm-fade { from { opacity: 0; } to { opacity: 1; } }
  @keyframes bm-pop {
    from { opacity: 0; transform: translateY(14px) scale(0.97); }
    to { opacity: 1; transform: none; }
  }
`;
